import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-86863438"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "income-permission-badge"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("span", _hoisted_1, "含内购收入");
}